// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const InStock = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="currentColor"
                d="M6,0 C2.68593764,0 0,2.68593764 0,6 C0,9.31406236 2.68593764,12 6,12 C9.31406236,12 12,9.31406236 12,6 C12,2.68593764 9.31406236,0 6,0 Z M8.71406221,4.96406257 L5.71406221,7.96406221 C5.58515632,8.09296846 5.41874993,8.15625 5.25,8.15625 C5.08125007,8.15625 4.91390634,8.09252357 4.78570318,7.96434402 L3.28570318,6.46434402 C3.02999997,6.20793772 3.02999997,5.79192209 3.28570318,5.53551579 C3.54210949,5.27910948 3.95812511,5.27910948 4.21453142,5.53551579 L5.25,6.57187486 L7.78593779,4.03593779 C8.04234409,3.77953148 8.45835972,3.77953148 8.71476603,4.03593779 C8.96953154,4.29140639 8.96953154,4.70859361 8.71406221,4.96406257 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(InStock);
